import Vue from "vue";
import Vuex from "vuex";
import { client } from "./myaxios";
import cookies from "vue-cookies";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // for tenant
    cities: "",
    city: "",
    // for layout
    layout: "empty",
    // for topic layout only
    structuredCategories: [],
    currentCategoryId: "",
    categories: [],
    // shared
    topicsUrl: "/topics",
    tagsUrl: "/tags",
    // for user login only
    status: "",
    token: cookies.get("token") || "",
    user: "",
    loading: false,
    theme: "dark",
    showLoginModalSwitch: false
  },
  getters: {
    getCategoryColorById: state => category_id => {
      for (var i = 0; i < state.categories.length; i++) {
        if (category_id === state.categories[i].id) {
          return state.categories[i].color;
        }
      }
      return "#fff";
    },
    getCategoryNameById: state => category_id => {
      for (var i = 0; i < state.categories.length; i++) {
        if (category_id === state.categories[i].id) {
          return state.categories[i].name;
        }
      }
      return "";
    },
    currentCategory: state => () => {
      for (var i = 0; i < state.categories.length; i++) {
        if (state.currentCategoryId === state.categories[i].id) {
          return state.categories[i];
        }
      }
      return "";
    },
    menuCategories: state => {
      var categories = [];
      for (var i = 0; i < state.structuredCategories.length; i++) {
        if (state.structuredCategories[i].display_order > -1) {
          let copy = JSON.parse(JSON.stringify(state.structuredCategories[i]));
          if (copy.subcategories.length > 0) {
            copy.subcategories = copy.subcategories.filter(
              c => c.display_order > -1
            );
          }
          categories.push(copy);
        }
      }
      return categories;
    },
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    getCity: state => state.city
  },
  mutations: {
    // for setting layout only
    setLayout(state, payload) {
      state.layout = payload;
    },
    // for setting tenant relatied fields: city,cities
    setCity(state, payload) {
      state.city = payload;
    },
    setCities(state, payload) {
      state.cities = payload;
    },
    // for topic layout only
    modifyCategories(state) {
      client
        .get("/categories", {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Accept: "application/json"
          }
        })
        .then(response => {
          state.structuredCategories = response.data.data;
          for (var i = 0; i < response.data.data.length; i++) {
            state.categories.push(response.data.data[i]);
            for (
              var j = 0;
              j < response.data.data[i].subcategories.length;
              j++
            ) {
              state.categories.push(response.data.data[i].subcategories[j]);
            }
          }
        });
    },
    changeCurrentCategory(state, id) {
      state.currentCategoryId = id;
    },
    //goToSubdomain
    goToSubdomain(state, subdomain) {
      // window.location =
      //   "http://" +
      //   subdomain +
      //   ".99huaren.local:8080" +
      //   window.location.pathname;
      state.loading = true;
      let hostname = window.location.hostname;
      // remove any subdomains, e.g. www.example.com -> example.com
      let domain = hostname.match(
        /^(?:.*?\.)?(\w{3,}\.(?:\w{2,8}|\w{2,4}\.\w{2,4}))$/
      )[1];

      var location = window.location.protocol + "//" + subdomain + "." + domain;
      if (window.location.port) {
        location += ":" + window.location.port;
      }
      // location += "/categories/market";
      window.location = location;
    },
    // shared
    setUrls(state, payload) {
      if (payload.topicsUrl !== null) {
        state.topicsUrl = payload.topicsUrl;
      }

      if (payload.tagsUrl !== null) {
        state.tagsUrl = payload.tagsUrl;
      }
    },
    // for user login only
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, payload) {
      state.status = "success";
      state.token = payload.token;
      state.user = payload.user;
    },
    auth_error(state) {
      state.status = "error";
      delete Vue.prototype.$http.defaults.headers.common["Authorization"];
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.user = {};
      Vue.prototype.$http.defaults.headers.common["Authorization"] = "";
      window.Echo.connector.pusher.config.auth.headers["Authorization"] = "";
    },
    updateUser(state, user) {
      state.user = user;
    },
    loginWithToken(state, token) {
      let bearerToken = "Bearer " + token;
      Vue.prototype.$http.defaults.headers.common[
        "Authorization"
      ] = bearerToken;
      window.Echo.connector.pusher.config.auth.headers[
        "Authorization"
      ] = bearerToken;
      // get current user
      Vue.prototype.$http
        .get("/user")
        .then(resp => {
          // localStorage.setItem("token", token);
          cookies.set(
            "token",
            token,
            "1d",
            "/",
            process.env.VUE_APP_API_COOKIE_DOMAIN || ".99huaren.com"
          );
          state.status = "success";
          state.token = token;
          state.user = resp.data;
        })
        .catch(() => {
          state.status = "error";
          delete Vue.prototype.$http.defaults.headers.common["Authorization"];
          // localStorage.removeItem("token");
          cookies.remove(
            "token",
            "/",
            process.env.VUE_APP_API_COOKIE_DOMAIN || ".99huaren.com"
          );
        });
    },
    //for UX only
    setShowLoginModalSwitch(state, payload) {
      state.showLoginModalSwitch = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setTheme(state, payload) {
      state.theme = payload;
    }
  },
  actions: {
    changeToCategory({ commit }, payload) {
      commit("changeCurrentCategory", payload);
    },
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        client({
          url: "/authorizations",
          data: user,
          method: "POST"
        })
          .then(resp => {
            // save token
            const token = resp.data.access_token;
            commit("loginWithToken", token);
            resolve(resp);
          })
          .catch(err => {
            console.log(err);
            commit("auth_error");
            // localStorage.removeItem("token");
            cookies.remove(
              "token",
              "/",
              process.env.VUE_APP_API_COOKIE_DOMAIN || ".99huaren.com"
            );
            reject(err);
          });
      });
    },
    updateUserInfo({ commit }, editedUser) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: "/user",
            data: editedUser,
            method: "PATCH"
          })
          .then(resp => {
            commit("updateUser", resp.data);
            resolve(resp);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    register({ commit }, user) {
      return new Promise((resolve, reject) => {
        client({
          url: process.env.VUE_APP_API_BASE_URL + "/register",
          data: user,
          method: "POST"
        })
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error", err);
            // localStorage.removeItem("token");
            cookies.remove(
              "token",
              "/",
              process.env.VUE_APP_API_COOKIE_DOMAIN || ".99huaren.com"
            );
            reject(err);
          });
      });
    },
    logout({ commit }) {
      return new Promise(resolve => {
        Vue.prototype
          .$http({
            url: "/authorizations/current",
            method: "DELETE"
          })
          .then(resp => {
            resolve(resp);
          });

        // localStorage.removeItem("token");
        cookies.remove(
          "token",
          "/",
          process.env.VUE_APP_API_COOKIE_DOMAIN || ".99huaren.com"
        );
        commit("logout");
        delete Vue.prototype.$http.defaults.headers.common["Authorization"];
      });
    }
  }
});
